import { createSelector } from "reselect";

const selectQualificationSideBar = (state) => state.qualificationSideBar;
export const selectIsQualificationSideBarOpen = createSelector(
    selectQualificationSideBar,
    (selectQualificationSideBar) => selectQualificationSideBar.isQualificationSideBarOpened,
);
export const selectQualificationSideBarSelection = createSelector(
    selectQualificationSideBar,
    (selectQualificationSideBar) => selectQualificationSideBar.qualificationSideBarSelection,
);
